import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Modal,
  Dimmer,
  Loader,
} from 'semantic-ui-react';
import CloseSVG from '../assets/icons/close.svg';

export default class PackagingPricingModal extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    header: PropTypes.string,
    onClose: PropTypes.func,
    loading: PropTypes.bool,
    content: PropTypes.func,
    modalState: PropTypes.bool,
  }
  static getPropsToState = (props) => {
    const state = {};
    // control modal state externally instead of based on trigger if modalState provided
    if (props.modalState) state.open = props.modalState;
    return {
      ...state,
    };
  }
  constructor(props) {
    super(props);
    const state = PackagingPricingModal.getPropsToState(props);
    this.state = {
      open: false,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = PackagingPricingModal.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUpdate() {
    this.fixBody();
  }
  componentDidUpdate() {
    this.fixBody();
  }
  fixBody = () => {
    const anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal && anotherModal.length > 0) {
      document.body.classList.add('dimmable', 'dimmed');
    }
  }
  handleOnOpen = () => {
    this.setState({ open: true });
  }
  handleOnClose = () => {
    this.setState({ open: false }, () => {
      if (this.props.onClose) {
        this.props.onClose();
      }
    });
  }
  render() {
    const { open } = this.state;
    return (
      <Modal
        className="upload-modal packagePricingModal"
        open={open}
        onOpen={this.handleOnOpen}
        onClose={() => this.handleOnClose()}
        size="large"
      >
        <section className="modal-header text-header">
          {this.props.header}
          <Button
            basic
            className="closeButton"
            onClick={() => this.handleOnClose()}
          >
            <img src={CloseSVG} alt="close" />
          </Button>
        </section>
        <Dimmer
          inverted style={{ zIndex: 1 }}
          active={this.props.loading}
        >
          <Loader inline="centered">Loading</Loader>
        </Dimmer>
        <Modal.Content>
          {this.props.content({ open, onClose: this.handleOnClose })}
        </Modal.Content>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PackagingPricingModal.jsx